export const getSplittedTitle = (title: string): string[] => {
  // Check if the title starts with something like "Step 1," "Steg 2," etc. This is to be able to seperate "Step 1" from the rest of the title
  const regex = /(^(?:Step|Steg).*?),/;
  // Remove empty strings from array possibly created by the split
  const splittedString = title.split(regex).filter(Boolean);
  return splittedString;
};
